"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInlineTableField = void 0;
const form_field_1 = require("./form-field");
const inline_table_field_1 = require("../../../components/inline-table-field/inline-table-field");
exports.FormInlineTableField = form_field_1.formFieldFactory(inline_table_field_1.InlineTableField);
//# sourceMappingURL=form-inline-table-field.js.map